import isAdmin from 'utils/session/isAdmin';
export function getHasAnnouncement(announcement) {
  var hasAnnouncement = !!announcement && isAdmin() && !announcement.isRead && !announcement.isDismissed;
  return hasAnnouncement;
}